module.exports = __webpack_public_path__ + "democratic-republic-of-congo.svg?945491f22d5bce4a855b59bcc523456f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/democratic-republic-of-congo.svg
// module id = 148
// module chunks = 10